import Cookies from "universal-cookie"

import config from "../config"
import getCompleteApiUrl from "../getCompleteApiUrl"
import {MissionObjective} from "../../classes/MissionObjective"
import {ApiCallFailure} from "../../classes/exception/ApiCallFailure";

async function addObjectiveToMissionById(objective: MissionObjective) {
    const cookies = new Cookies()

    if (cookies.get("accessToken") === undefined) {
        const error = new ApiCallFailure()
        error.connectionSuccessful = false
        error.errorType = "NO_ACCESS_TOKEN"

        throw error
    }

    var res: Response
    try {
        res = await fetch(getCompleteApiUrl(config, `/missions/id/${objective.missionId}/objectives`), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${cookies.get("accessToken")}`
            },
            body: JSON.stringify({description: objective.description}),
        })
    } catch (error) {
        const apiFailure = new ApiCallFailure()
        apiFailure.connectionSuccessful = false

        throw apiFailure
    }
    
    if (res!.status === 201) {
        const responseObject = await res!.json()
        
        const responseObjective = new MissionObjective()
        responseObjective.parseObject(responseObject)
        
        return responseObjective
    }

    const callFailure = new ApiCallFailure()
    callFailure.connectionSuccessful = true
    callFailure.responseCode = res!.status
    callFailure.errorType = "REQUEST_REJECTED"

    throw callFailure
}

export default addObjectiveToMissionById